import { Component, OnInit, ViewChild, Inject, ElementRef } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatAutocomplete } from '@angular/material/autocomplete';
import { MatChipList } from '@angular/material/chips';
import { DynamicFormComponent } from 'src/app/CommonComponents/dynamic-form/components/dynamic-form/dynamic-form.component';
import { CommonService } from 'src/app/Service/Common.service';
import { CommunicationService } from 'src/app/Service/communication/communication.service';
import { IMessageInputModel, IMsgElementInputModel, IMsgSLNoInputModel, IMsgDocumentInputModel, IMsgAttachmentInputModel, IMsgReceiverInputModel, IMessageGroupListModel, IMsgAttachmentsModel, IMsgDocumentAttachmentModel, IMessageGroupOutputModel } from 'src/app/ViewModel/CommunicationModel';
import { IProjectElementDetailsOutput, IProjectElementsOutput } from 'src/app/ViewModel/ProjectElementsModel';
import { StandardOutputModel } from 'src/app/ViewModel/StandardOutputModel';
import { Align } from '@progress/kendo-angular-popup';
import { ISignatureOutputModel } from 'src/app/ViewModel/CommunicationModel';
import { NotificationService } from 'src/app/Service/notification.service';
import { FieldConfig } from 'src/app/CommonComponents/dynamic-form/interface/field.interface';

import { ProjectInfoService } from 'src/app/Service/project-info/project-info.service';
import { formatDate } from '@angular/common';
import { ExternalMemberService } from 'src/app/Service/member/external-member.service';
import { SignatureComponent } from 'src/app/Modules/communication/signature/signature.component';
import { ProjectMemberLinkService } from 'src/app/Service/projectMemberLink/project-member-link.service';
import { Module } from 'src/app/Service/element-details.data.service';
import { FileUploadComponent } from '../file-upload/file-upload.component';
import { ITransmittalMemberModel } from 'src/app/ViewModel/TransmittalTemplateModel';
import { ProjectMemberModel } from 'src/app/ViewModel/ProjectMemberModel';
import { TransmittalService } from 'src/app/Service/transmittal-template/transmittal-template.service';
import { debounceTime, exhaustMap, filter, scan, startWith, switchMap, tap } from 'rxjs/operators';
import { COMMA, ENTER, SPACE } from '@angular/cdk/keycodes';
import { DocumentMessageViewComponent } from '../document-message-grid/document-message-view/document-message-view.component';
import { FileUploadLibrary } from 'src/app/Service/file/file.service';
import { ElementLinkService } from 'src/app/Service/element-link/element-link.service';
import { ProjectViewModel } from 'src/app/ViewModel/ProjectModel';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { of } from 'rxjs/internal/observable/of';


@Component({
  selector: 'app-create-communication',
  templateUrl: './create-communication.component.html',
  styleUrls: ['./create-communication.component.css']
})
export class CreateCommunicationComponent implements OnInit {


  @ViewChild("docSetForm")
  dynamicForm!: DynamicFormComponent;
  panelOpenState = true;
  public inputType: any;
  public selectedMessages!: any[];
  public messageFormat!: string;
  public numFormat!: string;
  public readonly!: boolean;
  public responseRequired!: string;
  public projectId!: number;
  public groupId!: number;
  public memberId!: number;
  public parentMessageId: number = 0;
  public msgNo!: string;
  public MessageId!: number;
  public autoSerialNo!: string;
  public msgSerialNo!: number;
  public messageNo!: string;
  public isMessageValid!: boolean;
  public projectElements: IProjectElementsOutput[] = [];
  public numElements: Map<string, string> = new Map<string, string>();
  public elementInp: IMsgElementInputModel[] = [];
  public elementInput: IMsgElementInputModel[] = [];
  public mailType: string = '';
  public messageGroup: string = '';
  public mailTypeList: IProjectElementDetailsOutput[] = [];
  public membersList: any[] = [];
  public CurrentProjectDetails!: ProjectViewModel;
  masterMembers: ITransmittalMemberModel[] = [];
  @ViewChild('toInput')
  toInput!: ElementRef<HTMLInputElement>;
  @ViewChild('toauto')
  matToAutoComplete!: MatAutocomplete;
  @ViewChild('toChipList')
  toChipList!: MatChipList;
  @ViewChild('ccInput')
  ccInput!: ElementRef<HTMLInputElement>;
  @ViewChild('ccauto')
  matCcAutoComplete!: MatAutocomplete;
  @ViewChild('ccChipList')
  ccChipList!: MatChipList;
  @ViewChild('bccInput')
  bccInput!: ElementRef<HTMLInputElement>;
  @ViewChild('bccauto')
  matbccAutoComplete!: MatAutocomplete;
  @ViewChild('bccChipList')
  bccChipList!: MatChipList;
  toMembers: ITransmittalMemberModel[] = [];
  tofilter$!: Observable<any>;
  toFilteredMembers!: Observable<ITransmittalMemberModel[]>;
  ccMembers: ITransmittalMemberModel[] = [];
  ccfilter$!: Observable<any>;
  ccFilteredMembers!: Observable<ITransmittalMemberModel[]>;
  bccMembers: ITransmittalMemberModel[] = [];
  bccfilter$!: Observable<any>;
  bccFilteredMembers!: Observable<ITransmittalMemberModel[]>;
  private _nextPage$ = new Subject();
  private _destroyed$ = new Subject();
  selectedTo!: number;
  separatorKeysCodes: number[] = [ENTER, SPACE, COMMA];
  selectable = true;
  removable = true;
  addOnBlur = true;
  multiple = false;
  isShowSerialNo = true;
  serialNoLength: number = 5;
  public messageForm: FormGroup = new FormGroup({
    txtMsgSerialNo: new FormControl({ value: '', disabled: true }),
    txtSerialNo: new FormControl({ value: '', disabled: true }, [Validators.pattern("^[0-9]*$")]),
    lblIsConfidential: new FormControl(true),
    autoMailType: new FormControl(),
    ddlMailType: new FormControl(),
    autoMailFrom: new FormControl(),
    ddlMailFrom: new FormControl()
  });
  public messageContentForm: FormGroup = new FormGroup({
    txtMailSubject: new FormControl(),
    editor: new FormControl()
  });
  elementsConfig: FieldConfig[] = [];
  mailContent: string = '';
  registermailContent: string = '';
  mailSubject: string = '';
  IsShowAttachmentList = false;
  /*Signature*/
  IsShowPopup = false;
  public IsDisabled!: boolean;
  public anchorElementPopup: any;
  public anchorAlignCenter: Align = { horizontal: 'center', vertical: 'bottom' };
  private popupAlignCenter: Align = { horizontal: 'center', vertical: 'top' };
  private anchorAlignRight: Align = { horizontal: 'right', vertical: 'bottom' };
  private popupAlignRight: Align = { horizontal: 'right', vertical: 'top' };
  private anchorAlignLeft: Align = { horizontal: 'left', vertical: 'bottom' };
  private popupAlignLeft: Align = { horizontal: 'left', vertical: 'top' };
  public margin = { horizontal: -15, vertical: 10 };
  public signatureList: ISignatureOutputModel[] = [];
  public documentList: any[] = [];
  public messageList: any[] = [];
  receivedDoc: any[] = [];
  mgList: any[] = [];
  groupList: IMessageGroupOutputModel[] = [];
  bindGroupList: IMessageGroupOutputModel[] = [];
  mailFrom: string = '';
  public fromList: any[] = [];
  mailTo: string = '';
  public toList: any[] = [];
  mailCC: string = '';
  public ccList: any[] = [];
  mailBCC: string = '';
  public bccList: any[] = [];
  public messageGroupForm!: FormGroup;
  public isRevisedDateInvalid!: boolean;
  public canManualNo: boolean = false;
  public datevalue = new Date(this.getDateFormat());
  public RespondOn: string = formatDate(this.datevalue, 'dd-MM-yyyy', 'en-US');
  public sentdatevalue = new Date(this.getDateFormat());
  public SentOn: string = formatDate(this.sentdatevalue, 'dd-MM-yyyy', 'en-US');
  public isSentDateInvalid!: boolean;
  public mailFromList: any[] = [];
  attachmentsList: IMsgDocumentAttachmentModel[] = [];
  constructor(
    private _projService: ProjectInfoService,
    public communicationService: CommunicationService,
    public commonService: CommonService,
    public memberService: ExternalMemberService,
    public projectMemberLinkService: ProjectMemberLinkService,
    private _elementLinkService: ElementLinkService,
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<CreateCommunicationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private notificationService: NotificationService,
    private formBuilder: FormBuilder,
    private transmittalService: TransmittalService,
  ) { }

  ngOnInit() {
    this.inputType = this.data['inputType'];
    this.messageFormat = 'Mail';
    this.numFormat = 'Auto';
    this.readonly = true;
    this.IsDisabled = true;
    this.responseRequired = 'No';
    this.projectId = this.commonService.getProjectId();
    this.groupId = this.commonService.getLoggedInUserGroupId();
    this.memberId = this.commonService.getLoggedInUserId();
    this.CurrentProjectDetails = this.commonService.getCurrentProjectDetails();
    if (this.CurrentProjectDetails && this.CurrentProjectDetails.doc_Number_Format) {
      this.numFormat = this.CurrentProjectDetails.doc_Number_Format;
      this.onNumFormatChange(this.numFormat);
    }
    this.callMemberRoleandFeature();
    this.createCommunicationForm();
    this.getSerialNoLength();
    this.getDynamicForm();
    this.getSignatureList();
    this.getMailTypelist();
    this.getMailFromList();
    this.getMembers();
    this.getMessageGroupList();
    if (this.inputType == 'createDocumentMail' && this.data['selectedList'] != undefined && this.data['selectedList'].length > 0) {
      this.documentList = this.data['selectedList'];
    }
    else if (this.inputType != 'createMail' && this.data['selectedList'] != undefined && this.data['selectedList'].length > 0) {
      this.setMessageResponder();
    }
    else if (this.inputType == 'registerMail') {
      this.messageFormat = 'Register Incoming Message';
    }
    this.getRegisterContent();
    this.messageGroupForm.controls['txtNoOfDays'].setValue(0);
    this.transmittalService.getProjectMembers().subscribe((res: ProjectMemberModel[]) => {
      this.masterMembers = res.map(x => {
        let transmittalMember: ITransmittalMemberModel = {
          memberId: x.memberId,
          memberName: x.memberName,
          memberShortName: x.memberShortName,
          eMailId: x.eMailId,
          mobileNo: x.mobileNo,
          staffPSNo: x.staffPSNo
        };
        return transmittalMember;
      });
      this.tofilter$ = this.createSerachFilter('toMembersCtrl');
      this.ccfilter$ = this.createSerachFilter('ccMembersCtrl');
      this.bccfilter$ = this.createSerachFilter('bccMembersCtrl');
      this.filterMembers();
    });

  }
  createCommunicationForm() {
    this.messageGroupForm = this.formBuilder.group({
      toMembersCtrl: new FormControl(),
      ccMembersCtrl: new FormControl(),
      bccMembersCtrl: new FormControl(),
      toMembers: [[], [Validators.required, this.validateMemberSelection.bind(this)]],
      ccMembers: [[], [Validators.required, this.validateMemberSelection.bind(this)]],
      bccMembers: [[], [Validators.required, this.validateMemberSelection.bind(this)]],
      txtNoOfDays: new FormControl(),
      formToMember: new FormControl('', Validators.required),
      formMGList: new FormControl('', Validators.required)

    });
  }
  async getMembers() {
    this.membersList = await this.memberService.GetMembersList({ group_Id: this.groupId, member_Id: null }).toPromise();
  }

  async getSerialNoLength() {
    let slNoArray = await this._elementLinkService.getNumberingSlNoLength(this.projectId, this.groupId, Module.Communication).toPromise();
    this.serialNoLength = slNoArray.serialNoLength != 0 ? slNoArray.serialNoLength : 5;
  }

  getRegisterContent() {
    if (this.messageFormat == 'Register Incoming Message') {
      var futureDate = formatDate(new Date(), 'dd-MM-yyyy', 'en-US');;
      this.registermailContent = '<br><br><br><br><br><br><br>This mail is registered by ';
      this.registermailContent += this.commonService.getLoggedInUserName();
      this.registermailContent += ' on ';
      this.registermailContent += futureDate;
      this.messageContentForm.controls['editor'].setValue(this.registermailContent);
    }
  }
  async setMessageResponder() {
    this.selectedMessages = this.data['selectedList'];
    this.parentMessageId = this.selectedMessages[0];
    let receivers = await this.communicationService.GetMessageReceiverList(this.parentMessageId).toPromise();
    if (this.inputType == 'replyMail') {
      this.toList = receivers.filter((x: any) => x.receiverType == 1).map((x: any) => {
        return {
          value: x.memberId,
          title: x.memberName,
          isGroup: x.receiverGroup != 0,
          isActive: true,
          groupId: x.receiverGroup,
          groupName: x.receiverGroup != 0 ? x.receiverGroupName : ""
        }
      });
      this.mailTo = this.toList.map(x => x.title).toString();
      this.messageGroupForm.controls['txtMailTo'].setValue(this.mailTo);
    }
    if (this.inputType == 'replyAllMail') {
      this.toList = receivers.filter((x: any) => x.receiverType == 1).map((x: any) => {
        return {
          value: x.memberId,
          title: x.memberName,
          isGroup: x.receiverGroup != 0,
          isActive: true,
          groupId: x.receiverGroup,
          groupName: x.receiverGroup != 0 ? x.receiverGroupName : ""
        }
      });
      this.mailTo = this.toList.map(x => x.title).toString();
      this.messageGroupForm.controls['txtMailTo'].setValue(this.mailTo);
      this.ccList = receivers.filter((x: any) => x.receiverType == 3).map((x: any) => {
        return {
          value: x.memberId,
          title: x.memberName,
          isGroup: x.receiverGroup != 0,
          isActive: true,
          groupId: x.receiverGroup,
          groupName: x.receiverGroup != 0 ? x.receiverGroupName : ""
        }
      });
      this.mailCC = this.getMembersText(this.ccList);
      this.messageGroupForm.controls['txtMailCC'].setValue(this.mailCC);
      this.bccList = receivers.filter((x: any) => x.receiverType == 5).map((x: any) => {
        return {
          value: x.memberId,
          title: x.memberName,
          isGroup: x.receiverGroup != 0,
          isActive: true,
          groupId: x.receiverGroup,
          groupName: x.receiverGroup != 0 ? x.receiverGroupName : ""
        }
      });
      this.mailBCC = this.getMembersText(this.bccList);
      this.messageGroupForm.controls['txtMailBCC'].setValue(this.mailBCC);
    }
  }

  getMembersText(list: IMessageGroupListModel[]) {
    let noGroup = list.filter(x => x.isGroup == false).map(x => x.title);
    let result = list.filter(x => x.isGroup).map(x => x.groupName);
    let filteredResult = result.filter((n, i) => result.indexOf(n) === i);
    return noGroup.toString() + filteredResult.toString();
  }

  onMessageFormatChange(value: any) {
    this.messageFormat = value;
    // this.reSet();
    if (this.messageFormat == 'Register Incoming Message') {
      this.getRegisterContent();
    }
  }
  onNumFormatChange(value: any) {
    this.numFormat = value;
    this.isShowSerialNo = this.numFormat == 'Auto' || this.numFormat == 'Semi';
    if (this.numFormat == 'Auto') {
      this.messageForm.get('txtMsgSerialNo')?.disable();
      this.messageForm.get('txtSerialNo')?.disable();
      this.GetMessageSerialNo();
    } else if (this.numFormat == 'Semi') {
      this.messageForm.get('txtSerialNo')?.enable();
      this.messageForm.get('txtMsgSerialNo')?.disable();
      this.GetMessageSerialNo();
    }
    else if (this.numFormat == 'Manual') {
      this.messageForm.get('txtMsgSerialNo')?.setValue('');
      this.messageForm.get('txtSerialNo')?.setValue('');
      this.messageForm.get('txtMsgSerialNo')?.enable();
      this.messageForm.get('txtSerialNo')?.disable();
    }
  }
  public getMessageNumber(): string {
    let docNo: string = this.getFormValue("txtMsgSerialNo", this.messageForm);
    if (this.numFormat == 'Auto' || this.numFormat == 'Semi')
      return docNo + '-' + this.getFormValue("txtSerialNo", this.messageForm);
    else
      return docNo;
  }
  onResponseRequiredChange(value: any) {
    this.responseRequired = value;
  }
  getDynamicForm() {
    this._projService.getProjectElements({ projectId: this.projectId, groupId: this.groupId, moduleId: Module.Communication, IsQueryForStaticElement: false }).subscribe(
      (res: IProjectElementsOutput[]) => {

        this.projectElements = res;
        this.elementsConfig = res.map(x => {
          let field: FieldConfig;
          let childDEId = null;
          let childDEDescription = "";
          let data = res.filter(item => item.dependentElementId == x.elementId);

          if (data.length > 0) {
            childDEId = data[0].elementId;
            childDEDescription = data[0].elementDescription;
          }

          field = {
            de_id: x.elementId,
            module_id: Module.Communication,
            dependent_de_id: x.dependentElementId,
            dependent_de_Description: x.dependentElementDescription,
            child_de_id: childDEId,
            child_de_Description: childDEDescription,
            name: x.elementDescription,
            deDescription: x.elementDescription,
            type: 'select',
            value: new BehaviorSubject(null)
          }
          if (x.isMandatory) {
            field.validations = [
              {
                name: "required",
                validator: Validators.required,
                message: field.name + " Required"
              }
            ]
          }
          if (x.isNumbering) {
            this.numElements.set(x.elementDescription, '');
          }
          return field;
        });
        this.dynamicForm.fields = this.elementsConfig;
        this.dynamicForm.createControl();

        let resForm: FormGroup = this.dynamicForm.value;
        //Numbering elements array
        let numberingElements: string[] = Array.from(this.numElements.keys());
        numberingElements.forEach(element => {
          resForm.get(element)?.valueChanges.subscribe((x: any) => {

            if (this.numElements.has(element)) {
              this.numElements.set(element, x.dedShortDescription);
            }
            if (!!x && (this.numFormat == 'Auto' || this.numFormat == 'Semi')) {
              this.GetMessageSerialNo();
            }
          });
        });
        this.onCascadingAutocomplete_Change();
      });
  }

  onCascadingAutocomplete_Change() {
    this.elementsConfig.forEach(data => {
      if (!!data.child_de_id && data.deDescription) {
        this.dynamicForm.form.get(data.deDescription)?.valueChanges.subscribe((x: any) => {
          let resForm: FormGroup = this.dynamicForm.value;
          let _field = this.dynamicForm.getCascadingAutocompleteDetails(data.child_de_Description);
          let parentControlSelectedValue: IProjectElementDetailsOutput = data.deDescription ? resForm.get(data.deDescription)?.value : null;

          if (_field.length > 0 && !!parentControlSelectedValue) {
            this._projService.getProjectElementCascadingDetails({
              projectId: this.projectId,
              groupId: this.groupId,
              moduleId: Module.Communication,
              deId: _field[0].de_id,
              deDescription: _field[0].deDescription,
              dependentDEId: _field[0].dependent_de_id,
              dependentDEDId: parentControlSelectedValue.dedId
            }).subscribe((res: IProjectElementDetailsOutput[]) => {
              if (res.length > 0) {
                res.map(val => val.displayText = val.dedShortDescription + " - " + val.dedDescription);
                _field[0].values = res;
              }
              else {
                _field[0].values = [];
                /*this._projService.getProjectElementDetails({
                  projectId: this.projectId,
                  groupId: this.groupId,
                  moduleId: Module.Communication,
                  deId: _field[0].de_id,
                  deDescription: _field[0].deDescription
                }).subscribe((res: IProjectElementDetailsOutput[]) => {
                  if (res.length > 0) {
                    res.map(val => val.displayText = val.dedShortDescription + " - " + val.dedDescription);
                    _field[0].values = res;
                  }
                }, err => { });*/
              }
            }, (err: any) => { });
          }
          else {
            _field[0].values = [];
            /*this._projService.getProjectElementDetails({
              projectId: this.projectId,
              groupId: this.groupId,
              moduleId: Module.Transmittal,
              deId: _field[0].de_id,
              deDescription: _field[0].deDescription
            }).subscribe((res: IProjectElementDetailsOutput[]) => {
              if (res.length > 0) {
                res.map(val => val.displayText = val.dedShortDescription + " - " + val.dedDescription);
                _field[0].values = res;
              }
            }, err => { });*/
          }
        })
      }
    })
  }

  /**
   * Get elementDetailsForm Controls value
   * @param controlName ControlName
   */
  getFormValue(controlName: string, formGroup: FormGroup): any {
    return formGroup.get(controlName)?.value;
  }
  /**
     *Get Message Serial No
     */
  GetMessageSerialNo() {
    //Coin the Document number based on the element values selection changes
    let elementValues: string[] = Array.from(this.numElements.values());
    let selectedElementValues: string[] = elementValues.filter(val => val != '');
    this.msgNo = elementValues.filter(val => val != '').join('-');
    this.messageForm.get('txtMsgSerialNo')?.setValue(this.msgNo);
    //Ensure all the mandatory numering elements selected
    if (elementValues.length > 0 && elementValues.length == selectedElementValues.length) {

      let resForm: FormGroup = this.dynamicForm.value;
      this.elementInp = this.projectElements.filter(x => x.isNumbering).map(x => {
        let selectedValue: IProjectElementDetailsOutput = resForm.get(x.elementDescription)?.value;
        let result: IMsgElementInputModel = {
          deId: x.elementId,
          dedId: selectedValue.dedId,
          deDescription: x.elementDescription,
          dedDescription: selectedValue.dedDescription,
          dedShortDescription: selectedValue.dedShortDescription,
          sortBy: +selectedValue.sortBy
        }
        return result;
      });
      let inputModel: IMsgSLNoInputModel = { projectId: this.commonService.getProjectId(), groupId: 1, moduleId: 4, elementDetails: this.elementInp };
      this.communicationService.GetMsgSerialNo(inputModel).subscribe((result: StandardOutputModel) => {

        //Set manipulated value from the parent component(W.r.t other documents elements selection while bulk upload)
        this.msgSerialNo = +result.result;
        this.messageForm.get('txtSerialNo')?.setValue(String(this.msgSerialNo).padStart(this.serialNoLength, '0'));
        this.messageNo = this.msgNo + "-" + String(this.msgSerialNo).padStart(this.serialNoLength, '0');
      });
    }
  }
  /**
  * Get Mail Type
  */
  public getMailTypelist() {
    this._projService.getProjectElementDetails({ projectId: this.projectId, groupId: this.groupId, moduleId: Module.Communication, deDescription: 'Mail Type' })
      .subscribe((res: IProjectElementDetailsOutput[]) => {
        this.mailTypeList = res;
      }, (err: any) => { });
  }
  public async getMailFromList() {
    this.mailFromList = await this.projectMemberLinkService.getSelectedMemberList(this.projectId, this.groupId).toPromise();
  }
  setMessageValues(event: any, formControlName: string) {
    if (formControlName == 'ddlMailType') {
      this.mailType = event.text;
    }
    this.messageForm.get(formControlName)?.setValue(event.value);
  }
  /**
 * Save Message Input
 */


  getMessageInput() {
    if (this.messageForm.valid) {
      let resForm: FormGroup = this.dynamicForm.value;
      this.elementInput = this.projectElements.map(x => {
        let selectedValue: IProjectElementDetailsOutput = resForm.get(x.elementDescription)?.value;
        let result: IMsgElementInputModel = {
          deId: x.elementId,
          dedId: selectedValue.dedId,
          deDescription: x.elementDescription,
          dedDescription: selectedValue.dedDescription,
          dedShortDescription: selectedValue.dedShortDescription,
          sortBy: +selectedValue.sortBy
        }
        return result;
      });

      let docAttachments = this.documentList.map(x => {
        let result: IMsgDocumentInputModel = {
          memberId: this.memberId,
          messageId: 0,
          docId: x.docId,
          revisionNo: x.revision,
          response: 0,
          responseRemarks: null,
          isActive: true
        }
        return result;
      });
      let msgAttachments = this.messageList.map(x => {
        let result: IMsgAttachmentInputModel = {
          memberId: this.memberId,
          messageId: 0,
          attachedMessageId: x.messageId,
          isActive: true
        }
        return result;
      });
      let msgReceivers = this.setMessageReceivers();
      let disciplineId = 0;
      let discipline = this.elementInput.find(x => x.deDescription == 'Discipline');
      if (discipline != undefined) {
        disciplineId = discipline.dedId;
      }
      let category = this.mailType == "Request For Information" ? 5 : 2;
      category = this.mailType == "Non Conformity Report" ? 7 : 2;
      let semiNo: string = '0';
      let msgNo: string = this.getFormValue("txtMsgSerialNo", this.messageForm);
      if (this.numFormat == 'Semi' || this.numFormat == 'Auto') {
        semiNo = this.getFormValue("txtSerialNo", this.messageForm);
        semiNo = semiNo.replace(/\D|^0+/g, "");
        msgNo = msgNo + '-' + this.getFormValue("txtSerialNo", this.messageForm);
      }
      let inputModel: IMessageInputModel = {
        CanSendMail: false,
        MessageNo: msgNo,
        ProjectId: this.projectId,
        GroupId: this.groupId,
        MemberId: this.memberId,
        MessageId: this.MessageId,
        MsgSerialNo: +semiNo,
        DisciplineId: disciplineId,
        ParentMessageId: this.parentMessageId,
        MessageType: this.getFormValue('ddlMailType', this.messageForm),
        HasAttachments: this.documentList.length > 0 || this.messageList.length > 0,
        IsConfidential: this.getFormValue('lblIsConfidential', this.messageForm),
        MessageCategory: category,
        MessageSubject: this.getFormValue('txtMailSubject', this.messageContentForm),
        MessageBody: this.mailContent != '' ? this.mailContent : this.getFormValue('editor', this.messageContentForm),
        ResponseType: this.getFormValue('txtNoOfDays', this.messageGroupForm),
        RespondOn: this.responseRequired == 'No' ? null : this.RespondOn,
        IssueReason: 10,
        SentOn: (this.messageFormat != 'Register Incoming Message') ? null : this.SentOn,
        elementDetails: this.elementInput,
        documentAttachments: this.documentList.length > 0 ? docAttachments : [],
        messageAttachments: this.messageList.length > 0 ? msgAttachments : [],
        messageReceivers: msgReceivers,
        CurrentProjectDetails: this.CurrentProjectDetails
      };
      return inputModel;
    }
    return null;
  }

  saveMessage() {
    let inputModel = this.getMessageInput();
    if (inputModel != null) {
      this.communicationService.InsertMessage(inputModel).subscribe((res: StandardOutputModel) => {
        if (res.successCode == 200) {
          this.notificationService.showToast(res.successMessage, "Success");
          this.updateAttachmentsMessgeId(+res.result);
          // this.reSet();
          this.closeDialog();
        }
        else if (res.successCode == 205) {
          this.notificationService.showToast(res.successMessage, "Warning");
          this.updateAttachmentsMessgeId(+res.result);
          // this.reSet();
        }
        else {
          this.notificationService.showToast(res.successMessage, "Error");
        }
      });
    }
    else {
      this.notificationService.showToast("Mandatory fields are Required", "Warning");
    }
  }

  updateAttachmentsMessgeId(messageId: number) {
    if (this.attachmentsList.length > 0) {
      let attachedDoc: IMsgAttachmentsModel = { projectId: this.projectId, msgId: messageId, createdBy: this.memberId, messageDocuments: this.attachmentsList }
      this.communicationService.updateCommunicationDocsMsgId(attachedDoc).subscribe((res: StandardOutputModel) => {
        if (res.successCode != 200) {
          this.notificationService.showPopup(res.successMessage, "Warning");
        }
      });
    }
  }


  async sendMessage() {

    let inputModel = this.getMessageInput();
    if (inputModel != null && this.toMembers.length > 0 && this.messageContentForm.valid) {
      let msgReceivers = inputModel.messageReceivers;

      let category = this.mailType == "Request For Information" ? 4 : 1;
      category = this.mailType == "Non Conformity Report" ? 6 : 1;
      inputModel.CanSendMail = true;
      inputModel.MessageCategory = category;
      inputModel.SentOn = this.SentOn;
      this.communicationService.InsertMessage(inputModel).subscribe((res: StandardOutputModel) => {
        if (res.successCode == 200 || res.successCode == 205) {
          this.notificationService.showToast(res.successMessage, "Success");
          this.updateAttachmentsMessgeId(+res.result);
          this.closeDialog();
          // this.attachmentClick(res.result);
        }
        else {
          this.notificationService.showToast(res.successMessage, "Warning");
        }
      });
    }
    else {
      this.notificationService.showToast("Mandatory fields are Required", "Warning");
    }
  }

  setMessageReceivers() {
    let receivers: IMsgReceiverInputModel[] = [];

    //this.toMembers.push(this.toMembers);

    if (this.mailType != "Request For Information" && this.messageFormat != 'Register Incoming Message') {
      receivers.push({
        memberId: this.memberId,
        messageId: 0,
        receiverType: 1,
        receiverGroup: 0,
        responseDate: null,
        sortBy: 0,
        faxCopy: null,
        hardCopy: null,
        isDeleted: false,
        isRead: 'U',
        readOn: null,
        userId: this.memberId,
        isActive: true
      });
    } else {
      receivers.push({
        memberId: this.getFormValue('ddlMailFrom', this.messageForm),
        messageId: 0,
        receiverType: 1,
        receiverGroup: 0,
        responseDate: null,
        sortBy: 0,
        faxCopy: null,
        hardCopy: null,
        isDeleted: false,
        isRead: 'U',
        readOn: null,
        userId: this.memberId,
        isActive: true
      });
    }
    if (this.messageFormat == 'Register Incoming Message') {
      receivers.push({
        memberId: this.memberId,
        messageId: 0,
        receiverType: 4,
        receiverGroup: 0,
        responseDate: null,
        sortBy: 0,
        faxCopy: null,
        hardCopy: null,
        isDeleted: false,
        isRead: 'U',
        readOn: null,
        userId: this.memberId,
        isActive: true
      });
    }
    this.toMembers.forEach(x => {
      receivers.push({
        memberId: x.memberId,
        messageId: 0,
        receiverType: 2,
        receiverGroup: 0,
        responseDate: null,
        sortBy: 1,
        faxCopy: null,
        hardCopy: null,
        isDeleted: false,
        isRead: 'U',
        readOn: null,
        userId: this.memberId,
        isActive: true
      });
    });
    this.ccMembers.forEach(x => {
      receivers.push({
        memberId: x.memberId,
        messageId: 0,
        receiverType: 3,
        receiverGroup: 0,
        responseDate: null,
        sortBy: 0,
        faxCopy: null,
        hardCopy: null,
        isDeleted: false,
        isRead: 'U',
        readOn: null,
        userId: this.memberId,
        isActive: true
      });
    });

    this.bccMembers.forEach(x => {
      receivers.push({
        memberId: x.memberId,
        messageId: 0,
        receiverType: 5,
        receiverGroup: 0,
        responseDate: null,
        sortBy: 0,
        faxCopy: null,
        hardCopy: null,
        isDeleted: false,
        isRead: 'U',
        readOn: null,
        userId: this.memberId,
        isActive: true
      });
    });
    return receivers;
  }
  openSignaturePopup() {
    this.IsShowPopup = false;
    const dialogRef = this.dialog.open(SignatureComponent, {
      panelClass: 'mat-dialog-secondary',
      width: '60%',
      maxWidth: '60vw'
    });
    dialogRef.afterClosed().subscribe((res: any) => {
      this.getSignatureList();
      if (res != undefined) {
        let editorText = this.getFormValue('editor', this.messageContentForm);
        this.mailContent = (editorText != null ? editorText : '<br/>') + res;
      }
    });
  }
  selectSignature(sign: any) {
    let editorText = this.getFormValue('editor', this.messageContentForm);
    this.mailContent = (editorText != null ? editorText : '<br/>') + sign.signatureText;
  }
  public showSignList(event: any) {
    if (this.signatureList.length > 0) {
      this.IsShowPopup = !this.IsShowPopup;
      this.anchorElementPopup = event.target;
    }
  }
  public closeSignList() {
    this.IsShowPopup = false;
    this.anchorElementPopup = undefined;
  }
  public getSignatureList() {
    this.communicationService.GetSignatureList({ MemberId: this.memberId })
      .subscribe((res: ISignatureOutputModel[]) => {
        this.signatureList = res;
      }, (err: any) => { });
  }
  public showAttachmentList(event: any) {
    this.IsShowAttachmentList = !this.IsShowAttachmentList;
    this.anchorElementPopup = event.target;
  }
  public closeAttachmentList() {
    this.IsShowAttachmentList = false;
    this.anchorElementPopup = undefined;
  }
  showDocumentCart() {
    let obj: any = {}
    obj["type"] = "Select Document";
    if (this.documentList.length > 0) {
      obj["data"] = this.documentList;
    }
    this.IsShowAttachmentList = false;
    const dialogRef = this.dialog.open(DocumentMessageViewComponent, {
      panelClass: 'mat-dialog-primary',
      data: obj
    });
    dialogRef.afterClosed().subscribe((res: any) => {
      if (res.length > 0) {
        this.receivedDoc = res.filter((data: any) => data.isSelected == true);
        Array.prototype.push.apply(this.documentList, this.receivedDoc);
      }
      else {
        if (this.documentList.length < 0) {
          this.documentList = [];
        }
      }
    });
  }
  removeDocument(dataItem: any) {
    this.documentList.forEach((value, index) => {
      if (value.docId == dataItem.docId) {
        this.documentList.splice(index, 1);
      }
    });
  }
  showMessageCart() {
    let obj: any = {}
    obj["type"] = "Select Message";
    if (this.messageList.length > 0) {
      obj["data"] = this.messageList;
    }
    this.IsShowAttachmentList = false;
    const dialogRef = this.dialog.open(DocumentMessageViewComponent, {
      panelClass: 'mat-dialog-primary',
      data: obj
    });
    dialogRef.afterClosed().subscribe((res: any) => {
      if (res.length > 0) {
        this.receivedDoc = res.filter((data: any) => data.isSelected == true);
        Array.prototype.push.apply(this.messageList, this.receivedDoc);
      }
      else {
        if (this.messageList.length < 0) {
          this.messageList = [];
        }
      }
    });
  }
  removeMessage(dataItem: any) {
    this.messageList.forEach((value, index) => {
      if (value.messageId == dataItem.messageId) {
        this.messageList.splice(index, 1);
      }
    });
  }

  deleteFile(rowIndex: any) {
    this.attachmentsList.splice(rowIndex, 1);
  }
  getDateFormat() {
    let today = new Date();
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = today.toLocaleString('default', { month: 'short' })
    var yyyy = today.getFullYear();
    let today1 = dd + '-' + mm + '-' + yyyy;
    return today1;
  }
  getValue(selectedText: any) {
    this.isRevisedDateInvalid = selectedText.value == null;
    this.RespondOn = selectedText.value;
  }
  getSentOnValue(selectedText: any) {
    this.isSentDateInvalid = selectedText.value == null;
    this.SentOn = selectedText.value;
  }
  getTimeValue(selectedText: any) {
  }
  addDays() {
    let value = this.getFormValue('txtNoOfDays', this.messageGroupForm);
    if (!isNaN(value)) {
      var futureDate = new Date();
      futureDate.setDate(futureDate.getDate() + value);
      this.RespondOn = formatDate(futureDate, 'dd-MM-yyyy', 'en-US');;
      this.datevalue = futureDate;
      return futureDate;
    }
    else {
      this.notificationService.showToast("Enter Valid Number", "Warning");
    }
    return null;
  }

  validateMemberSelection(abstractControl: AbstractControl): ValidationErrors | null {
    if (abstractControl.touched || abstractControl.dirty) {
      let selectedValue: any[] = abstractControl.value;
      if (selectedValue && !selectedValue.every(member => this.masterMembers.includes(member))) {
        return { IsError: true };
      } else {
        return null;
      }
    }
    return null;
  }

  private createSerachFilter(formControlName: string): Observable<any> {
    // Note: listen for search text changes
    let x: any = this.messageGroupForm
    return x ? x.get(formControlName).valueChanges.pipe(
      startWith(''),
      debounceTime(200),
      filter(q => typeof q === "string")) : new Observable<any>();;
  }
  private filterMembers(): void {
    this.toFilteredMembers = this.getFilteredMembers(this.tofilter$);
    this.ccFilteredMembers = this.getFilteredMembers(this.ccfilter$);
    this.bccFilteredMembers = this.getFilteredMembers(this.bccfilter$);
  }
  private getFilteredMembers(filter$: Observable<any>): Observable<ITransmittalMemberModel[]> {
    return filter$.pipe(
      switchMap((filter: any) => {
        //Note: Reset the page with every new seach text
        let currentPage = 1;
        return this._nextPage$.pipe(
          startWith(currentPage),
          exhaustMap(_ => this.getMembersFake(filter, currentPage)),
          tap(() => currentPage++),
          scan((allMembers, newMembers) => allMembers.concat(newMembers), []),
        );
      }
      ))
  }
  // Fake backend api
  private getMembersFake(startsWith: string, page: number): any {
    const take = 10;
    const skip = page > 0 ? (page - 1) * take : 0;
    const filtered = this.masterMembers
      .filter((option: any) => option.memberName.toLowerCase().includes(startsWith.toLowerCase()));
    return of(filtered.slice(skip, skip + take));
  }

  onselectedValueChange(val: any, formGroupName: string, formControlName: string) {
    switch (formGroupName) {
      case "message":
        this.messageGroupForm.get(formControlName)?.setValue(val.additionalValues.additionalValues);
        break;
    }
  }
  optionClicked(event: Event, member: ITransmittalMemberModel, type: string) {
    event.stopPropagation();
    switch (type) {
      case 'to':
        this.toggleToSelection(member);
        break;
      case 'cc':
        this.toggleCcSelection(member);
        break;
      case 'bcc':
        this.togglebccSelection(member);
        break;
    }
  }


  isMemberSelected(member: ITransmittalMemberModel, type: string): boolean {
    let result: boolean = false;
    switch (type) {
      case 'to':
        result = this.toMembers != null ? this.toMembers.findIndex(x => x.memberId == member.memberId) > -1 : false
        break;
      case 'cc':
        result = this.ccMembers != null ? this.ccMembers.findIndex(x => x.memberId == member.memberId) > -1 : false
        break;
      case 'bcc':
        result = this.bccMembers != null ? this.bccMembers.findIndex(x => x.memberId == member.memberId) > -1 : false
        break;
    }
    return result;
  }

  toggleToSelection(member: ITransmittalMemberModel) {
    const index: number = this.toMembers != null ? this.toMembers.findIndex(x => x.memberId == member.memberId) : 0;
    if (index > -1) {
      this.toMembers.splice(index, 1);
      this.toFormMembers?.value.splice(index, 1);
      this.toFormMembers?.updateValueAndValidity();
    }
    else {
      this.toMembers.push(member);
      this.toFormMembers?.value.push(member);
      this.toFormMembers?.updateValueAndValidity();
      this.resetToMemberFilter();
    }
  }
  resetToMemberFilter() {
    this.messageGroupForm.get('toMembersCtrl')?.setValue('');
    this.toInput.nativeElement.value = '';
    this.toInput.nativeElement.blur();
  }
  removeTo(member: ITransmittalMemberModel): void {
    const index = this.toMembers.indexOf(member);
    if (index >= 0) {
      this.toMembers.splice(index, 1);
      if (this.toFormMembers?.status != "VALID") {
        // Remove element from control value array
        this.toFormMembers?.value.splice(index, 1);
        // where index = index of removed element
        this.toFormMembers?.updateValueAndValidity();
      }
      this.resetToMemberFilter();
    }
  }

  toggleCcSelection(member: ITransmittalMemberModel) {
    const index: number = this.ccMembers != null ? this.ccMembers.findIndex(x => x.memberId == member.memberId) : 0;
    if (index > -1) {
      this.ccMembers.splice(index, 1);
      this.ccFormMembers?.value.splice(index, 1);
      this.ccFormMembers?.updateValueAndValidity();
    }
    else {
      this.ccMembers.push(member);
      this.ccFormMembers?.value.push(member);
      this.ccFormMembers?.updateValueAndValidity();
      this.resetCcMemberFilter();
    }
  }
  resetCcMemberFilter() {
    this.messageGroupForm.get('ccMembersCtrl')?.setValue('');
    this.ccInput.nativeElement.value = '';
    this.ccInput.nativeElement.blur();
  }
  removeCc(member: ITransmittalMemberModel): void {
    const index = this.ccMembers.indexOf(member);
    if (index >= 0) {
      this.ccMembers.splice(index, 1);
      if (this.ccFormMembers?.status != "VALID") {
        // Remove element from control value array
        this.ccFormMembers?.value.splice(index, 1);
        // where index = index of removed element
        this.ccFormMembers?.updateValueAndValidity();
      }
      this.resetCcMemberFilter();
    }
  }

  togglebccSelection(member: ITransmittalMemberModel) {
    const index: number = this.bccMembers != null ? this.bccMembers.findIndex(x => x.memberId == member.memberId) : 0;
    if (index > -1) {
      this.bccMembers.splice(index, 1);
      this.bccFormMembers?.value.splice(index, 1);
      this.bccFormMembers?.updateValueAndValidity();
    }
    else {
      this.bccMembers.push(member);
      this.bccFormMembers?.value.push(member);
      this.bccFormMembers?.updateValueAndValidity();
      this.resetbccMemberFilter();
    }
  }
  resetbccMemberFilter() {
    this.messageGroupForm.get('bccMembersCtrl')?.setValue('');
    this.bccInput.nativeElement.value = '';
    this.bccInput.nativeElement.blur();
  }

  removebcc(member: ITransmittalMemberModel): void {
    const index = this.bccMembers.indexOf(member);
    if (index >= 0) {
      this.bccMembers.splice(index, 1);
      // Remove element from control value array
      this.bccFormMembers?.value.splice(index, 1);
      // where index = index of removed element
      this.bccFormMembers?.updateValueAndValidity();
      this.resetbccMemberFilter();
    }
  }


  // use getter method to access toMembers control value easily
  get toFormMembers() {
    return this.messageGroupForm.get('toMembers');
  }
  get ccFormMembers() {
    return this.messageGroupForm.get('ccMembers');
  }
  get bccFormMembers() {
    return this.messageGroupForm.get('bccMembers');
  }

  closeDialog() {
    this.dialogRef.close();
  }

  clickLocalAttachment() {
    const dialog = this.dialog.open(FileUploadComponent, {
      panelClass: 'mat-dialog-secondary',
      width: '50%',
      data: { projectId: this.projectId, msgId: -1, libraryName: FileUploadLibrary.Communication, createdBy: this.memberId, documents: [{ value: -1, text: this.messageNo, revisionNo: "" }], isEditable: false },
    });
    dialog.componentInstance.onUploadFinished.subscribe(res => {
      let fileName: string = res.fileName;
      let fileExtn: string = fileName.substring(fileName.lastIndexOf(".") + 1);
      this.attachmentsList.push({ fileId: -1, fileName: fileName.substring(0, fileName.lastIndexOf(".")), fileExtension: fileExtn, fileSize: res.fileSize });
    });
  }

  async callMemberRoleandFeature() {
    this.commonService.getProjectMemberRoles(this.projectId, this.groupId, this.memberId).subscribe((result: any[]) => {

    });
    await this.commonService.getProjectMemberFeatures(this.projectId, this.memberId, this.groupId).subscribe((result1: any[]) => {
      this.canManualNo = result1.some(data => data.feature_Desc == 'Manual No');
      if (!this.canManualNo && this.numFormat == 'Manual')
        this.numFormat = 'Auto';
    });

  }

  async getMessageGroupList() {
    this.groupList = await this.communicationService.GetMessageGroup({ MemberId: this.memberId, ProjectId: this.projectId }).toPromise();
    let mgList1 = this.groupList.map((element => {
      return { "groupId": element.groupId, "groupDescription": element.groupDescription };
    }));
    this.mgList = mgList1.reduce((accumalator: any, current: any) => {
      if (
        !accumalator.some(
          (item: any) => item.groupId === current.groupId && item.groupDescription === current.groupDescription
        )
      ) {
        accumalator.push(current);
      }
      return accumalator;
    }, []);

  }

  onMGValueChange(event: any, formControlName: string) {

    if (formControlName == 'formMGList') {
      this.messageGroup = event.text;
    }
    // this.messageGroupForm.get(formControlName)?.setValue(event.value);
    this.bindMembers(event.value);
  }
  bindMembers(value: any) {
    this.bindGroupList = this.groupList.filter(x => x.groupId == value);
    this.toList = this.bindGroupList.filter(x => x.receiverType == 2).map(x => {
      return {
        value: x.memberId,
        title: x.memberName,
        isGroup: x.receiverType != 0,
        isActive: true,
        groupId: x.groupId,
        groupName: x.groupDescription
      }
    });

    this.toMembers = this.getMGListMembers(this.toList);
    if (this.toMembers != null) {
      this.toMembers = this.toMembers.filter(data => data != null);
      this.toFormMembers?.setValue([...this.toMembers]);
    }
    this.toFormMembers?.updateValueAndValidity();
    this.resetToMemberFilter();

    this.ccList = this.bindGroupList.filter(x => x.receiverType == 3).map(x => {
      return {
        value: x.memberId,
        title: x.memberName,
        isGroup: x.receiverType != 0,
        isActive: true,
        groupId: x.groupId,
        groupName: x.groupDescription
      }
    });

    this.ccMembers = this.getMGListMembers(this.ccList);
    if (this.ccMembers != null) {
      this.ccMembers = this.ccMembers.filter(data => data != null);
      this.ccFormMembers?.setValue([...this.ccMembers]);
    }
    this.ccFormMembers?.updateValueAndValidity();
    this.resetCcMemberFilter();

    this.bccList = this.bindGroupList.filter(x => x.receiverType == 5).map(x => {
      return {
        value: x.memberId,
        title: x.memberName,
        isGroup: x.receiverType != 0,
        isActive: true,
        groupId: x.groupId,
        groupName: x.groupDescription
      }
    });

    this.bccMembers = this.getMGListMembers(this.bccList);
    if (this.bccMembers != null) {
      this.bccMembers = this.bccMembers.filter(data => data != null);
      this.bccFormMembers?.setValue([...this.bccMembers]);
    }
    this.bccFormMembers?.updateValueAndValidity();
    this.resetbccMemberFilter();
  }

  private getMGListMembers(members: any): ITransmittalMemberModel[] {


    return members.map((x: any) => {
      let findmember = this.masterMembers.filter(y => y.memberId == x.value)[0];
      if (!!findmember) {
        let member: ITransmittalMemberModel = {
          memberId: x.value,
          memberName: x.title,
          memberShortName: findmember.memberShortName,
          eMailId: findmember.eMailId,
          staffPSNo: findmember.staffPSNo,
          mobileNo: findmember.mobileNo,
          groupBy: x.receiverGroup
        };
        return member;
      }
    });
  }

  omit_special_char(event) {
    var k;
    k = event.charCode;  //         k = event.keyCode;  (Both can be used)
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57) || (k > 43 && k < 48) || k==92 || k==95);
  }
}
